import { ArrowRightIcon } from '@heroicons/react/solid';
import { Input } from 'antd';
import React, { useState } from 'react';

import ButtonDefault, { ButtonVariants } from '../../shared/basic/button';
import { formateErrorObject } from '../../shared/formateErrorObject';
import { notify } from '../../shared/notify';
import { handleSubscribe } from '../../../services/Subscribe';

const Reachout: React.FC = () => {
  const [inputValue, setInputValue] = useState<string>();

  const [loading, setLoading] = useState(false);
  const [emailErrors, setEmailErrors] = useState('');
  const isValidEmailOrPhone = (value: string) => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    const phoneRegex = /^\d{10}$/;

    return emailRegex.test(value) || phoneRegex.test(value);
  };

  const handleSubscribeSubmit = async (email: string) => {
    try {
      setLoading(true);
      if (isValidEmailOrPhone(email)) {
        await handleSubscribe(email as string);
        setInputValue(undefined);
        notify('Subscribed Successfully', 'success');
        setEmailErrors('');
      } else {
        setEmailErrors('Please provide valid email address');
      }
    } catch (error: any) {
      const message = formateErrorObject(error);
      setEmailErrors(message);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      <div className='px-5  bg-bgColor flex justify-center items-center text-fadedWhite pb-20'>
        <div className=' flex justify-center w-full'>
          <div className='flex flex-col gap-y-10'>
            <div className='flex-col flex gap-y-4'>
              <span className='text-2xl lg:text-5xl flex justify-center font-medium text-center'>
                <p className='lg:w-2/3'>
                  Subscribe to Stay Connected and Hear from Us!
                </p>
              </span>
              <span className='text-center'>
                Subscribe with your email and receive the free sneak peek inside
                our books!
              </span>
            </div>

            <div className='flex justify-center'>
              <div className='flex flex-col gap-y-2'>
                <span className='flex flex-col sm:flex-row  gap-4 '>
                  <Input
                    size='large'
                    type='email'
                    autoComplete='current-email'
                    placeholder='Enter your email'
                    onChange={(e) => setInputValue(e.target.value)}
                    value={inputValue}
                    className='border text-sm focus-within:bg-bgColor  placeholder:text-textDarkGrayColor rounded-xl border-bgDarkGray  py-3  text-white bg-bgColor customInputBlack makeBgBlack'
                  />

                  <ButtonDefault
                    size={4}
                    variant={ButtonVariants.PRIMARY}
                    loading={loading}
                    disabled={loading}
                    roundedMd={true}
                    className='p-1 rounded-md'
                    onClick={() => {
                      if (inputValue) {
                        handleSubscribeSubmit(inputValue as string);
                      } else {
                        setEmailErrors('Please provide email to subscribe');
                      }
                    }}
                  >
                    <span className='flex text-xs rounded-md justify-center gap-x-2 px-4 py-1 whitespace-nowrap'>
                      SUBSCRIBE FOR FREE
                      <ArrowRightIcon className='w-4 h-4 text-white' />
                    </span>
                  </ButtonDefault>
                </span>
                <span className='text-sm pl-1'>
                  {emailErrors && (
                    <p className='text-red-500'>{emailErrors}</p>
                  )}{' '}
                </span>

                <span className='px-5 text-xs text-center md:text-start md:text-sm text-gray-400 pt-1'>
                  BY CLICKING SUBSCRIBE YOU'RE CONFIRMING THAT YOU AGREE WITH
                  OUR TERMS AND CONDITIONS.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reachout;
